import { Link } from "react-router-dom";
import type { GossipItem } from "@/mocks/gossip";
import { categories } from "@/mocks/gossip";
import { formatViews, getCategoryName } from "@/utils/format";

type VideoCardProps = {
  item: GossipItem;
  rank?: number;
};

export default function VideoCard({ item, rank }: VideoCardProps) {
  const categoryName = getCategoryName(item.category, categories);

  return (
    <article className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <Link to={`/video/${item.id}`} className="block cursor-pointer" aria-label={item.title}>
        <div className="relative w-full h-44 md:h-48 overflow-hidden bg-secondary-200">
          <img
            src={item.cover}
            alt={`${item.title} - ${categoryName}`}
            title={`${item.title} 视频吃瓜 ${categoryName}`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent"></div>

          {typeof rank === "number" ? (
            <span className="absolute top-3 left-3 inline-flex items-center justify-center w-8 h-8 rounded-md bg-accent-500 text-foreground-950 font-heading font-bold text-sm">
              {rank}
            </span>
          ) : item.hot ? (
            <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-md bg-primary-500 px-2 py-1 text-xs font-medium text-background-50">
              <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center"></i>
              热
            </span>
          ) : null}

          <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-md bg-foreground-950/70 px-1.5 py-0.5 text-xs text-background-50 font-label">
            <i className="ri-play-circle-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {item.duration}
          </span>

          <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-background-50/90 text-primary-600">
              <i className="ri-play-fill w-6 h-6 flex items-center justify-center"></i>
            </span>
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <span className="inline-flex w-fit items-center rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900 mb-2">
          {categoryName}
        </span>
        <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950">
          <Link to={`/video/${item.id}`} className="cursor-pointer transition-colors hover:text-primary-600">
            {item.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{item.excerpt}</p>
        <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-play-circle-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {formatViews(item.views)}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-heart-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {formatViews(item.likes)}
          </span>
          <span className="ml-auto">{item.date}</span>
        </div>
      </div>
    </article>
  );
}